import React from "react";
import { useTranslation } from "react-i18next";

export default function ActivityOptions(props) {
  const { t } = useTranslation();
  return (
    <li className="draw-toolbar-icon">
      <span
        className={`button normal-btn main-button ${
          props.activeButton === "teacher-tools" ? "active" : ""
        }${props.hideButton ? "passive" : ""}`}
        title={t("Teacher Tools")}
        data-tip={t("Teacher Tools")}
        onClick={props.onClick}
      >
        <img
          src={require("../../assets/img/svg/toolbar-lecture.svg")}
          alt={t("Teacher Tools")}
        />
      </span>
    </li>
  );
}
